import { TableContainer } from '@dealstack/frontend/shared/components/Documents/DocumentsTable/styled';
import { InnerContainer } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/ManageFileAssociationStep/components/TransactionInformationItem/styled';
import {
	LinkUploadContainer,
	MiddleContainer,
	SidePanelContainer,
} from '@dealstack/frontend/shared/components/Documents/UploadDocuments/ManageFileAssociationStep/styled';
import {
	StepContainer,
	TextContainer,
	Header,
	SubHeader,
} from '@dealstack/frontend/shared/components/Documents/UploadDocuments/styled';
import { Skeleton, Flex, Box } from '@mantine/core';

export const ManageFileAssociationSkelton = () => {
	return (
		<StepContainer>
			<Flex w="100%">
				{/* Left Side Panel Loader */}
				<SidePanelContainer $borderDirection="right">
					<TextContainer>
						<Header>
							<Skeleton height={20} width="60%" radius="sm" />
						</Header>
						<SubHeader>
							<Skeleton height={15} width="80%" radius="sm" />
						</SubHeader>
					</TextContainer>

					<LinkUploadContainer>
						<InnerContainer $disabled={true}>
							{[...Array(3)].map((_, index) => (
								<Box key={index} mb="sm">
									<Skeleton height={50} radius="sm" />
								</Box>
							))}
						</InnerContainer>
					</LinkUploadContainer>
				</SidePanelContainer>

				{/* Middle Container Loader */}
				<MiddleContainer>
					<TableContainer>
						{[...Array(5)].map((_, index) => (
							<Box key={index} mb="sm">
								<Skeleton height={30} radius="sm" />
							</Box>
						))}
					</TableContainer>
				</MiddleContainer>

				{/* Right Side Panel Loader */}
				<SidePanelContainer $borderDirection="left">
					<TextContainer>
						<Header>
							<Skeleton height={20} width="60%" radius="sm" />
						</Header>
						<SubHeader>
							<Skeleton height={15} width="80%" radius="sm" />
						</SubHeader>
					</TextContainer>

					<LinkUploadContainer>
						<InnerContainer $disabled={true}>
							{[...Array(3)].map((_, index) => (
								<Box key={index} mb="sm">
									<Skeleton height={50} radius="sm" />
								</Box>
							))}
						</InnerContainer>
					</LinkUploadContainer>
				</SidePanelContainer>
			</Flex>
		</StepContainer>
	);
};
